import React, { useState, useEffect, useReducer } from "react";
import Image from "next/legacy/image";
import { useRouter } from "next/router";

import { readDocument, updateDocument } from "@/lib/db";
import { useAuth } from "@/lib/auth";
import SignUpSignIn from "@/components/user/SignUpSignIn";
import Button from "@/ui/Button";

import HomeHeader from "@/components/home/HomeHeader";

import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";

import Breadcrumbs from "@/components/common/Breadcrumbs";
import { imageLoader } from "@/utils/image";
import moment from "moment";

/*


[0].questions[4].answer === "Yes"
*/

/*const defaultTimeline = [
    {
        index: 1,
        section: "Are you currently living in your own home or with family?",
        questions: [
            {
                question: "Are you currently living in your own home or with family",
                answer: "",
                answers: ["Yes", "No"],
            },
            {
                question: "If yes, Do you need to sell your house before moving in?",
                answer: "",
                answers: ["Yes", "No"],
            },
            {
                question: "Have you listed your property yet?",
                answer: "",
                answers: ["Yes", "No"],
            },
            {
                question:
                    "Would you consider waiting to sell your house until after you move into a community?",
                answer: "",
                answers: ["Yes", "No"],
            },
            {
                question: "Will you need to downsize your home?",
                answer: "",
                answers: ["Yes", "No"],
            },
        ],
    },
    {
        index: 2,
        section:
            "Is this move-in date based on a hospital, rehabilitation or skilled nursing facility discharge date?",
        questions: [
            {
                question:
                    " Is this move-in date based on a hospital, rehabilitation or skilled nursing facility discharge date?",
                answer: "",
                answers: ["Yes", "No"],
            },
        ],
    },
    {
        index: 3,
        section: "Are you moving from another senior living community?",
        questions: [
            {
                question: "Are you moving from another senior living community?",
                answer: "",
                answers: ["Yes", "No"],
            },
        ],
    },
    {
        index: 4,
        section: "Tell us about your relocation distance.",
        questions: [
            {
                question: "Tell us about your relocation distance.",
                answer: "",
                answers: ["Local", "Long distance", "Out-of-State"],
            },
        ],
    },
    {
        index: 5,
        section: "Do you know if you will need temporary housing?",
        questions: [
            {
                question: "Do you know if you will need temporary housing?",
                answer: "",
                answers: ["Yes", "No", "Not Sure"],
            },
        ],
    },
];*/

const defaultTimeline = [
    {
        version: 2,
        index: 1,
        question: "Do you need to sell your house before moving into a community?",
        answer: "",
        answers: ["Yes", "No"],
    },
    {
        index: 2,
        question: "Will you need to downsize your home?",
        answer: "",
        answers: ["Yes", "No"],
    },
    {
        index: 3,
        question:
            "Is this move-in date based on a hospital, rehabilitation or skilled nursing facility discharge date?",
        answer: "",
        answers: ["Yes", "No"],
    },
    {
        index: 4,
        question: "Are you moving from another senior living community?",
        answer: "",
        answers: ["Yes", "No"],
    },
    {
        index: 5,
        question: "Do you know if you will need temporary housing?",
        answer: "",
        answers: ["Yes", "No"],
    },
    {
        index: 6,
        question: "Are you moving to a new town/state?",
        answer: "",
        answers: ["Yes", "No"],
    },
];

const updateUser = async (user, questions, submittedTimeline) => {
    if (user.uid) {
        await updateDocument("users", user.uid, {
            ...user,
            timeline: questions,
            submittedTimeline: submittedTimeline ? submittedTimeline : "",
        });
    }
};

const reducer = (state, action) => {
    switch (action.type) {
        case "LOADING":
            return { ...state, loading: true };

        case "INIT":
            if (
                action.user.timeline &&
                action.user.timeline.length > 0 &&
                action.user.timeline[0].version === 2
            ) {
                return { ...state, loading: false, user: action.user };
            } else {
                return {
                    ...state,
                    loading: false,
                    user: { ...action.user, timeline: defaultTimeline },
                };
            }

        case "UPDATE": {
            const questions = JSON.parse(JSON.stringify(state.user.timeline));

            const question = questions.find((q) => q.question === action.question);
            if (question) {
                if (question.answer === action.answer) {
                    question.answer = "";
                } else {
                    question.answer = action.answer;
                }
            }

            updateUser(state.user, questions, state.user.submittedTimeline);

            return { ...state, user: { ...state.user, timeline: questions } };
        }

        case "SUBMIT":
            updateUser(
                state.user,
                state.user.timeline,
                action.submit ? moment().format("MM/DD/YYYY") : ""
            );

            return {
                ...state,
                user: {
                    ...state.user,
                    submittedTimeline: action.submit ? moment().format("MM/DD/YYYY") : "",
                },
            };

        case "RESET":
            return {
                ...state,
                user: {
                    ...state.user,
                    timeline: defaultTimeline,
                    submittedTimeline: "",
                },
            };

        default:
            return state;
    }
};

const Timeline = () => {
    const router = useRouter();
    const auth = useAuth();
    const [openSignUp, setOpenSignUp] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);
    const [state, dispatch] = useReducer(reducer, {
        loading: true,
        user: {
            submittedTimeline: "",
            timeline: defaultTimeline,
        },
    });

    const userId = auth.user ? auth.user.uid : "";

    useEffect(() => {
        const init = async (uid) => {
            dispatch({ type: "LOADING" });

            const user = await readDocument("users", uid);
            if (user) {
                dispatch({ type: "INIT", user });
            }
        };

        if (userId) {
            init(userId);
        }
    }, [userId]);

    const handleChange = (question, answer) => {
        dispatch({
            type: "UPDATE",
            question,
            answer,
        });
    };

    const handleSubmit = () => {
        dispatch({ type: "SUBMIT", submit: true });
        window.scrollTo(0, 0);
    };

    const handleDownloadPdf = () => {
        router.push("/resources/timeline-pdf");
        window.scrollTo(0, 0);
    };

    const handleUpdate = () => {
        dispatch({ type: "SUBMIT", submit: false });
        window.scrollTo(0, 0);
    };

    const handleReset = () => {
        if (window.confirm("Clear all selections?")) {
            dispatch({ type: "RESET" });
            window.scrollTo(0, 0);
        }
    };

    console.log("state", state);

    return (
        <div className="bg-gray-50">
            <HomeHeader fixed />
            <div className="container mx-auto pt-16 sm:pt-20 pb-4 px-4 sm:px-16">
                <Breadcrumbs
                    links={[
                        { name: "Resources", href: "/resources" },
                        {
                            name: "Timeline",
                            href: "/resources/living-preferences",
                        },
                    ]}
                />
            </div>
            <div>
                <div className="hidden sm:block">
                    <div className="relative w-full h-40 sm:h-72 bg-black">
                        <Image
                            loader={imageLoader}
                            src="https://cdn.purpledoorfinders.com/purpledoorfinders/right-fit-timeline"
                            alt="purple-door-finders-articles-for-memory-care"
                            layout="fill"
                            objectFit="cover"
                            objectPosition="0px -60px"
                            priority
                            unoptimized={false}
                            className="opacity-70"
                        />

                        <div className="flex justify-center">
                            <h1 className="absolute px-8 top-12 sm:top-32 text-3xl sm:text-5xl text-white font-headline font-bold">
                                Assisted Living Timeline
                            </h1>
                        </div>
                    </div>
                </div>

                <div className="sm:hidden">
                    <h1 className="px-4 text-3xl text-primary-500 font-headline font-bold">
                        Assisted Living Timeline
                    </h1>
                </div>

                {userId === "" ? (
                    <div className="container mx-auto mt-4 py-8 px-4 sm:px-16 bg-gray-300 rounded-lg">
                        <h4 className="font-bold text-2xl">
                            You need to be registed and signed in to use this tool and save
                            the information.
                        </h4>

                        <div className="mt-4 flex items-center">
                            <Button
                                className=""
                                onClick={() => {
                                    setOpenSignUp(true);

                                    gtag("event", "conversion", {
                                        send_to: "AW-10778046073/z0kvCMDQspMaEPncr5Mo",
                                    });
                                }}
                            >
                                Create Account
                            </Button>
                        </div>

                        <div className="mt-4">
                            Already have an account?
                            <buton
                                className="ml-4 text-purple-500 hover:underline"
                                onClick={() => setOpenSignIn(true)}
                            >
                                Sign In
                            </buton>
                        </div>
                    </div>
                ) : null}

                {(userId ? !state.loading : true) && !state.user.submittedTimeline ? (
                    <div className="container mx-auto py-12 px-4 sm:px-16">
                        <div>
                            <h2 className="text-3xl text-primary-500 font-bold font-headline">
                                Get Started
                            </h2>

                            <p className="mt-8">
                                The Assisted Living Timeline tool helps you understand the
                                time it will take to find your senior living option that
                                works best for you. This short questionnaire will guide you
                                and be a resource throughout your search for senior living.
                            </p>

                            <p className="mt-4">
                                Once completed you can download your timeline or save it to
                                your account so you can stay on track and get into your
                                senior living community when needed.
                            </p>

                            <hr className="my-8 border-black" />

                            <div className="flex flex-col space-y-8">
                                {/*state.user.timeline.map((section) => (
                                    <Section
                                        key={section.index}
                                        section={section}
                                        onChange={handleChange}
                                    />
                                ))*/}
                                {state.user.timeline.map((question) => (
                                    <Question
                                        key={question.index}
                                        question={question}
                                        onChange={handleChange}
                                    />
                                ))}
                            </div>

                            <div className="mt-8 flex justify-end">
                                <Button
                                    className="uppercase"
                                    onClick={handleSubmit}
                                    disabled={!userId}
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : null}

                {userId && !state.loading && state.user.submittedTimeline ? (
                    <div className="container mx-auto py-12 px-4 sm:px-16">
                        <div>
                            <h2 className="text-3xl text-primary-500 font-bold font-headline">
                                You're All Done!
                            </h2>

                            <p className="mt-8">
                                Your personal Assisted Living Timeline is complete. You now
                                have a guide to help you plan your senior and assisted
                                living search.
                            </p>

                            <hr className="my-8 border-black" />

                            {state.user.timeline[2].answer !== "Yes" ? (
                                <div>
                                    <p className="font-black text-xl text-primary-500">
                                        6-12 months before move-in date:
                                    </p>

                                    {state.user.timeline[0].answer === "Yes" ? (
                                        <Item title="Listing home">
                                            If the house needs to be sold before your move,
                                            listing a home should start no later than six
                                            months before the move-in date.
                                        </Item>
                                    ) : null}

                                    {state.user.timeline[1].answer === "Yes" ? (
                                        <Item title="Downsizing home">
                                            If your home needs to be sold before moving,
                                            downsizing should start no later than 6 months
                                            before the move-in date. An example of
                                            downsizing is preparing to transition from a 3
                                            bedroom house into a 1 bedroom unit.
                                        </Item>
                                    ) : null}

                                    <Item title="Researching your benefits">
                                        Know all of your financial resources for affording
                                        and qualifying for assisted living or other living
                                        options.
                                    </Item>

                                    <Item
                                        title="Financial assistance and long-term care
                                        documentation"
                                    >
                                        Review and understand all your benefits as they may
                                        determine which type of community you can qualify
                                        for and afford. Having this documentation collected
                                        and available is important when you are ready to
                                        decide and evaluate a community and care needs.
                                    </Item>

                                    <p className="mt-8 font-black text-xl text-primary-500">
                                        4-6 months before move-in date:
                                    </p>

                                    <Item title="Begin touring communities">
                                        4-6 months before the target move-in date.
                                    </Item>

                                    <Item title="Move-in document requirements">
                                        Each state has different requirements. Check with
                                        the community(s) you are interested in for their
                                        move-in documents and requirements at the initial
                                        tour. Communities on Purple Door Finders may have
                                        those documents available in their community
                                        listing.
                                    </Item>

                                    <Item title="Physician assessment">
                                        3 months prior to desired move-in date get a
                                        physician's assessment if required. Most states
                                        require a physician's assessment for assisted
                                        living. These assessments are generally valid for
                                        six months unless there is a new diagnosis or change
                                        in condition. If you are moving from a hospital or
                                        rehab facility, make sure the discharging physician
                                        completes this form.
                                    </Item>

                                    {state.user.timeline[0].answer === "Yes" ? (
                                        <Item title="Temporary housing needs">
                                            Research your temporary housing options, if you
                                            may need them. The community manager at your new
                                            building may have a list of hotels with
                                            partnership pricing. The new community may have
                                            a furnished temporary guest rental unit or may
                                            have loaner furniture.
                                        </Item>
                                    ) : (
                                        <Item title="Temporary housing needs">
                                            Be prepared for temporary housing needs, even if
                                            you do not expect a delay. Be aware that move-in
                                            dates for a community may be delayed due to
                                            unforeseen reasons, such as a unit renovation or
                                            if all necessary documents are not in place at
                                            the time of the move.
                                        </Item>
                                    )}

                                    <p className="mt-8 font-black text-xl text-primary-500">
                                        30 days - 4 months before move-in date:
                                    </p>

                                    <Item title="Schedule movers">
                                        Reserve as soon as you know your move-in date. Try
                                        to find movers that specialize in senior moving.
                                    </Item>

                                    {state.user.timeline[3].answer === "Yes" ? (
                                        <Item title="Check your terms">
                                            If you are in a community, check the terms of
                                            your leasing agreement. Be sure you understand
                                            the terms of vacating your unit and have
                                            adequate time to give notice. If you cannot find
                                            your leasing agreement, ask your community
                                            manager.
                                        </Item>
                                    ) : null}

                                    <p className="mt-8 font-black text-xl text-primary-500">
                                        30 days before move-in date:
                                    </p>

                                    <Item title="Deposit/reservation agreement">
                                        A reservation agreement typically requires a sum of
                                        money as a deposit to hold a unit. The community
                                        will define this length of time indicating when you
                                        need to take financial and/or physical possession.
                                    </Item>

                                    <Item title="Community assessment">
                                        State licensing may require all residents to be
                                        assessed by a staff member when moving into a
                                        community that offers assisted living. The staff
                                        member will also use the physician's assessment to
                                        help determine the care needs and associated care
                                        fees. At the time of the assessment, it is critical
                                        that the resident brings all of their medications
                                        including any over-the-counter medications,
                                        supplements or any medication taken on an as-needed
                                        basis.
                                    </Item>

                                    <Item title="Sign community lease agreement">
                                        Each community has its own proprietary leasing
                                        agreement which needs to be signed before the
                                        resident physically moves into the community. This
                                        can only be done after the assessment has been
                                        completed and all required documents are in place.
                                    </Item>

                                    {state.user.timeline[5].answer === "Yes" ? (
                                        <Item title="Health needs">
                                            If this is a geographical move, it is important
                                            to make prior arrangements for a new primary
                                            healthcare provider and a pharmacy resource. If
                                            you utilize a mail-order pharmacy, they will
                                            need adequate notification for a change of
                                            address.
                                        </Item>
                                    ) : null}

                                    <p className="mt-8 font-black text-xl text-primary-500">
                                        1-2 days prior to the residents arrival or on the
                                        day of move-in
                                    </p>

                                    <Item title="Prior to the resident's arrival">
                                        Bring all medications to the med-tech or caregiver
                                        in their original containers (not pill organizers).
                                        If the resident has been approved to manage their
                                        own medications, most communities require all
                                        medications to be stored in a locked container.{" "}
                                    </Item>
                                </div>
                            ) : null}

                            {state.user.timeline[2].answer === "Yes" ? (
                                <div>
                                    <p className="mt-8 font-black text-xl">
                                        Moving to assisted living from a hospital or
                                        rehabilitation facility
                                    </p>

                                    <p className="mt-4">
                                        If you are being discharged from a hospital or
                                        rehabilitation facility, your timeline for finding
                                        assisted living is predicated on the discharge date.
                                        This is often a short time period, and your
                                        decisions will need to be made fairly quickly.
                                    </p>

                                    <ul className="mt-4 ml-4 flex flex-col space-y-2 list-decimal">
                                        <li>
                                            <Bold>Confirm discharge date.</Bold> Find out
                                            the anticipated discharge date from the hospital
                                            discharge planner and the attending physician.
                                            Most insurance companies define how long a
                                            person may remain in the hospital. The patient's
                                            diagnosis determines the time allowed for a
                                            hospital stay.
                                        </li>
                                        <li>
                                            <Bold>
                                                Find a community with a flexible move-in
                                                date.
                                            </Bold>{" "}
                                            Most communities will provide you with some
                                            grace time for discharged residents.
                                        </li>
                                        <li>
                                            <Bold>
                                                Place a deposit on the community apartment
                                                or unit.
                                            </Bold>{" "}
                                            Bring your checkbook. Most communities do not
                                            accept credit cards.
                                        </li>
                                        <li>
                                            <Bold>
                                                Ask the community for ALL move-in documents.
                                            </Bold>{" "}
                                            This should include a resident handbook and a
                                            copy of the lease agreement to review.
                                        </li>
                                        <li>
                                            <Bold>
                                                Assessment of your health and care needs.
                                            </Bold>{" "}
                                            Many communities will assign a staff member to
                                            perform a hospital bedside assessment. If
                                            possible, a family member should be present to
                                            reassure the resident, especially if the
                                            resident is hard of hearing, has low vision, or
                                            memory-impaired.
                                        </li>
                                        <li>
                                            <Bold>
                                                Some of the community documents may require
                                                a signature from the attending physician.
                                            </Bold>{" "}
                                            These forms should be completed as soon as
                                            possible.
                                        </li>
                                        <li>
                                            <Bold>
                                                TB and other tests, such as Covid, are
                                                required by most communities.
                                            </Bold>{" "}
                                            These may require 48 to 72 hours before results
                                            are available. A negative chest x-ray report may
                                            be used in lieu of a TB test.
                                        </li>
                                        <li>
                                            <Bold>
                                                Community review of physicians' documents.
                                            </Bold>{" "}
                                            Physician recommendations and what the community
                                            staff member observes during their assess- ment
                                            will determine the care and service plan as well
                                            as the cost. Care fees are likely in addition to
                                            the base rate.
                                        </li>
                                        <li>
                                            <Bold>Schedule a moving company.</Bold> If a
                                            moving company is needed, try to find a moving
                                            company that specializes in senior living, which
                                            tends to be more flexible with move-in dates.
                                        </li>
                                        <li>
                                            <Bold>
                                                Check if the community offers ancillary
                                                services
                                            </Bold>{" "}
                                            such as a landline phone, cable, or internet
                                            access. If not, start making arrangements for
                                            these.
                                        </li>
                                        <li>
                                            <Bold>Sign the leasing agreement.</Bold> This
                                            document determines the date of financial and
                                            physical possession of the unit. Please note,
                                            that it is possible that rent starts before the
                                            resident has been discharged from the hospital.
                                        </li>
                                        <li>
                                            <Bold>Sign the care service agreement.</Bold> If
                                            the resident needs assisted living care, there
                                            will be a service agreement to be signed at the
                                            same time as the leasing agreement. This service
                                            plan will indicate any additional fees for care.
                                        </li>
                                        <li>
                                            <Bold>
                                                Final meeting with the discharge planner.
                                            </Bold>{" "}
                                            Be sure to ask all questions about the logistics
                                            of the transfer from the facility to the
                                            community. Ask if any medical equipment will be
                                            delivered or sent with the resident: walker,
                                            wheelchair, oxygen, hospital bed, or bedside
                                            commode. Understand if this will be covered by
                                            insurance or out-of-pocket, as well as if a
                                            family member needs to be present for delivery.
                                            For the transfer, know if will the resident be
                                            transported by private vehicle or require
                                            special transportation due to mobility
                                            restrictions or medical needs. Lastly, confirm
                                            if the facility will send medication with the
                                            resident.
                                        </li>
                                        <li>
                                            <Bold>Medication needs.</Bold> If the community
                                            will be managing the resident's medication, all
                                            medications (prescriptions and over-the-counter)
                                            must be given to the med-tech or nurse in their
                                            original bottles as soon as the resident
                                            arrives. Each medication will need to include
                                            the patient's name, drug name, dosage, and
                                            related diagnosis. A physician's written order
                                            is required in order to administer these items,
                                            even if they are non-prescription, such as
                                            vitamins.
                                        </li>
                                        <li>
                                            <Bold>Set up a community orientation.</Bold> To
                                            support the resident in the transition to the
                                            community, request family or a close friend to
                                            accompany them for an orientation. Consider
                                            staying for dinner or spending the first night
                                            with the resident. Review visitors policies and
                                            parking arrangements.
                                        </li>
                                        <li>
                                            <Bold>Contact information.</Bold> Ask for point
                                            of contact information to check in on your loved
                                            one, and how to gain entrance to the building
                                            after-hours.
                                        </li>
                                        <li>
                                            <Bold>Reassessment.</Bold> Inquire about the
                                            timing of a scheduled reassessment if the
                                            resident has improved and needs less care.
                                        </li>
                                    </ul>
                                </div>
                            ) : null}

                            <div className="mt-8 p-4 border-2 border-black">
                                <p>
                                    This timeline tool is a planning resource to help you
                                    search for senior and assisted living. It does not
                                    guarantee timeframes or dates; all are based on your
                                    community of choice and living needs.
                                </p>
                            </div>

                            <div className="mt-8 flex justify-start space-x-2 sm:space-x-8">
                                <Button className="uppercase" onClick={handleDownloadPdf}>
                                    Download as PDF
                                </Button>

                                <Button className="uppercase" onClick={handleUpdate}>
                                    Update Selections
                                </Button>

                                <Button
                                    variant="outlined"
                                    className="uppercase"
                                    onClick={handleReset}
                                >
                                    Clear All Selections
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>

            <SeoLinks />
            <HomeFooter />

            <SignUpSignIn
                openSignUp={openSignUp}
                openSignIn={openSignIn}
                setOpenSignUp={setOpenSignUp}
                setOpenSignIn={setOpenSignIn}
            />
        </div>
    );
};

const Bold = ({ children }) => {
    return <span className="font-black">{children}</span>;
};

const Question = ({ question, onChange }) => {
    return (
        <div className="">
            <h3 className="font-black">
                {question.index}. {question.question}
            </h3>

            <div className="mt-2 flex space-x-8">
                {question.answers.map((answer) => (
                    <div key={answer}>
                        <input
                            type="checkbox"
                            id={question.question + answer}
                            name={question.question + answer}
                            value={question.answer === answer}
                            checked={question.answer === answer}
                            onChange={() => onChange(question.question, answer)}
                        />
                        <label htmlFor={question.question + answer} className="ml-3">
                            {answer}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};

const Section = ({ section, onChange }) => {
    return (
        <div className="">
            <h3 className="font-black">
                {section.index}. {section.section}
            </h3>

            <div className="mt-2 flex flex-col space-y-0">
                {section.questions.map((question, index) => (
                    <div key={question.question} className="px-4">
                        {index > 0 ? (
                            <div className="mt-4 mb-2">{question.question}</div>
                        ) : null}

                        <div className="flex space-x-8">
                            {question.answers.map((answer) => (
                                <div key={answer}>
                                    <input
                                        type="checkbox"
                                        id={question.question + answer}
                                        name={question.question + answer}
                                        value={question.answer === answer}
                                        checked={question.answer === answer}
                                        onChange={() =>
                                            onChange(
                                                section.section,
                                                question.question,
                                                answer
                                            )
                                        }
                                    />
                                    <label
                                        htmlFor={question.question + answer}
                                        className="ml-3"
                                    >
                                        {answer}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const Item = ({ title, children }) => {
    return (
        <div className="mt-4">
            <span className="font-black">{title}:</span>
            <span className="ml-2">{children}</span>
        </div>
    );
};

export default Timeline;
